import { render } from "./cardFiltersIndexComponent.vue?vue&type=template&id=fa960446"
import script from "./cardFiltersIndexComponent.vue?vue&type=script&lang=js"
export * from "./cardFiltersIndexComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__